/**
 * Created by andrey on 31.08.17.
 */

cleverapps.Boosters = function (isNewUser) {
    this.boosterBeforeIds = cleverapps.Boosters.listBoostersBeforeIds();
    this.boosterIds = cleverapps.Boosters.listBoostersIds();

    this.boosters = {};
    this.createBoosters();

    if (isNewUser) {
        this.initialize();
    } else {
        this.load();
    }
};

cleverapps.Boosters.prototype.initialize = function () {
    this.data = {};
    this.addInitAmount();
};

cleverapps.Boosters.prototype.createBoosters = function () {
    this.boosterIds.concat(this.boosterBeforeIds).forEach(function (id) {
        const Ctor = cleverapps.Boosters.CONFIG[id].model;
        this.boosters[id] = new (Ctor)(id);
    }, this);
};

cleverapps.Boosters.prototype.addInitAmount = function () {
    let changed = false;
    this.listAll().forEach(function (booster) {
        if (this.data[booster.id] === undefined) {
            this.data[booster.id] = cleverapps.Boosters.INIT_AMOUNT;
            changed = true;
        }
    }, this);

    if (changed) {
        this.save();
    }
};

cleverapps.Boosters.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.BOOSTERS);
    this.data = data || {};
};

cleverapps.Boosters.prototype.save = function (updateServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.BOOSTERS, this.data);

    if (updateServer !== false) {
        connector.synchronizer.addSendTask("boosters");
    }
};

cleverapps.Boosters.prototype.getAmount = function (id) {
    return this.data[id] ? this.data[id] : 0;
};

cleverapps.Boosters.prototype.has = function (id) {
    return this.getAmount(id) > 0;
};

cleverapps.Boosters.prototype.take = function (id, count) {
    count = count || 1;

    if (this.has(id)) {
        let amount = this.getAmount(id) - count;
        if (amount < 0) {
            amount = 0;
        }
        this.setAmount(id, amount);
    }
};

cleverapps.Boosters.prototype.add = function (id, count) {
    count = count || 1;
    this.setAmount(id, this.getAmount(id) + count);
};

cleverapps.Boosters.prototype.setAmount = function (id, amount) {
    const oldAmount = this.getAmount(id);
    if (oldAmount !== amount) {
        this.data[id] = amount;
        this.save();
        this.boosters[id].onChange();
    }
};

cleverapps.Boosters.prototype.getBoosterById = function (id) {
    return this.boosters[id];
};

cleverapps.Boosters.prototype.getIdByType = function (type) {
    const suitableBoosters = [];

    for (const id in this.boosters) {
        if (this.boosters[id].type === type) {
            suitableBoosters.push(id);
        }
    }

    return PseudoRandom.GET().choose(suitableBoosters);
};

cleverapps.Boosters.prototype.listBoosters = function () {
    return this.boosterIds.map(function (id) {
        return this.boosters[id];
    }, this);
};

cleverapps.Boosters.prototype.listBoostersBefore = function () {
    return this.boosterBeforeIds.map(function (id) {
        return this.boosters[id];
    }, this);
};

cleverapps.Boosters.prototype.listAll = function () {
    return this.listBoostersBefore().concat(this.listBoosters());
};

cleverapps.Boosters.prototype.substituteByChain = function (type) {
    for (const step of cleverapps.Boosters.SUBSTITUTION_CHAINS[type] || [type]) {
        const id = this.getIdByType(step);
        if (id !== undefined) {
            return id;
        }
    }
};

cleverapps.Boosters.prototype.getCheapestId = function () {
    const types = [cleverapps.Boosters.TYPES.CHEAP, cleverapps.Boosters.TYPES.MEDIUM, cleverapps.Boosters.TYPES.EXPENSIVE];

    for (const type of types) {
        const id = this.getIdByType(type);
        if (id !== undefined) {
            return id;
        }
    }
};

cleverapps.Boosters.prototype.substituteBefore = function (hardValue) {
    const target = hardValue / 2;
    let best;
    this.boosterIds.forEach((id) => {
        const price = cleverapps.Boosters.getPrice(id);
        const diff = Math.abs(price - target) / target;
        if (diff <= cleverapps.Boosters.BEFORE_SUBSTITUTE_TOLERANCE && (!best || diff < best.diff)) {
            best = { id, diff };
        }
    });
    return best && best.id;
};

cleverapps.Boosters.prototype.resolveRewardBoosters = function (value) {
    const byBoosterId = {};
    let beforeHard = 0;

    Object.keys(value).forEach((key) => {
        const amount = value[key];
        if (!amount) {
            return;
        }

        let id;
        if (!cleverapps.Boosters.isType(key)) {
            id = this.getBoosterById(key) ? key : undefined;
        } else if (key.indexOf("before_") === 0) {
            id = this.getIdByType(key);
            if (id === undefined) {
                beforeHard += amount * cleverapps.Boosters.getPrice(key);
            }
        } else {
            id = this.substituteByChain(key);
        }

        if (id !== undefined) {
            byBoosterId[id] = (byBoosterId[id] || 0) + amount;
        }
    });

    if (beforeHard > 0) {
        const id = this.substituteBefore(beforeHard);
        if (id !== undefined) {
            byBoosterId[id] = (byBoosterId[id] || 0) + 1;
        }
    }

    return byBoosterId;
};

cleverapps.Boosters.listBoostersIds = function () {
    if (cleverapps.config.name === "scramble") {
        return [cleverapps.Boosters.TYPE_HINT, cleverapps.Boosters.TYPE_SHUFFLE];
    }
    if (cleverapps.config.type === "match3") {
        return [cleverapps.Boosters.TYPE_CELL, cleverapps.Boosters.TYPE_LINE, cleverapps.Boosters.TYPE_COLOR];
    }
    if (cleverapps.config.type === "board") {
        return [cleverapps.Boosters.TYPE_HINT, cleverapps.Boosters.TYPE_OPEN_LETTER];
    }
    if (cleverapps.config.type === "solitaire") {
        return [cleverapps.Boosters.TYPE_WILDCARD, cleverapps.Boosters.TYPE_UNDO];
    }
    if (cleverapps.config.name === "differences") {
        return [cleverapps.Boosters.TYPE_BRUSH, cleverapps.Boosters.TYPE_DISCOVER];
    }
    if (cleverapps.config.type === "tile3") {
        return [cleverapps.Boosters.TYPE_TILE_SHUFFLE, cleverapps.Boosters.TYPE_UNDO, cleverapps.Boosters.TYPE_VACUUM];
    }
    if (cleverapps.config.type === "blocks") {
        return [cleverapps.Boosters.TYPE_REPLACE_ALL, cleverapps.Boosters.TYPE_CLEAR_PIECES, cleverapps.Boosters.TYPE_UNDO_PIECE];
    }

    return [];
};

cleverapps.Boosters.listBoostersBeforeIds = function () {
    if (cleverapps.config.type === "match3") {
        return [cleverapps.Boosters.TYPE_COMBO, cleverapps.Boosters.TYPE_MOVES, cleverapps.Boosters.TYPE_MULTICOLOR];
    }

    if (cleverapps.config.type === "solitaire") {
        return [cleverapps.Boosters.TYPE_MAGNET, cleverapps.Boosters.TYPE_DICE, cleverapps.Boosters.TYPE_JOKERS];
    }

    if (cleverapps.config.subtype === "stacks") {
        return [cleverapps.Boosters.TYPE_HIGHLIGHT, cleverapps.Boosters.TYPE_EYE, cleverapps.Boosters.TYPE_MAGNIFIER];
    }

    return [];
};

cleverapps.Boosters.isType = function (id) {
    return Object.values(cleverapps.Boosters.TYPES).indexOf(id) !== -1;
};

cleverapps.Boosters.getPrice = function (booster) {
    let type;
    if (cleverapps.Boosters.isType(booster)) {
        type = booster;
    } else {
        type = cleverapps.Boosters.CONFIG[booster].type;
    }
    return RewardsConfig.Boosters[type].hard;
};

cleverapps.Boosters.SUBSTITUTION_CHAINS = {
    expensive: ["expensive", "medium", "cheap"],
    medium: ["medium", "cheap"],
    cheap: ["cheap"]
};

cleverapps.Boosters.BEFORE_SUBSTITUTE_TOLERANCE = 0.25;
cleverapps.Boosters.INIT_AMOUNT = 1;

cleverapps.Boosters.TYPE_CELL = 0;
cleverapps.Boosters.TYPE_LINE = 1;
cleverapps.Boosters.TYPE_COLOR = 2;

cleverapps.Boosters.TYPE_HINT = 3;
cleverapps.Boosters.TYPE_OPEN_LETTER = 24;

cleverapps.Boosters.TYPE_WILDCARD = 4;
cleverapps.Boosters.TYPE_SHUFFLE = 16;
cleverapps.Boosters.TYPE_BRUSH = 8;
cleverapps.Boosters.TYPE_DISCOVER = 9;

cleverapps.Boosters.TYPE_COMBO = 5;
cleverapps.Boosters.TYPE_MOVES = 6;
cleverapps.Boosters.TYPE_MULTICOLOR = 7;

cleverapps.Boosters.TYPE_MAGNET = 10;
cleverapps.Boosters.TYPE_DICE = 11;
cleverapps.Boosters.TYPE_JOKERS = 12;

cleverapps.Boosters.TYPE_HIGHLIGHT = 13;
cleverapps.Boosters.TYPE_EYE = 14;
cleverapps.Boosters.TYPE_MAGNIFIER = 15;

cleverapps.Boosters.TYPE_TILE_SHUFFLE = 17;
cleverapps.Boosters.TYPE_UNDO = 18;
cleverapps.Boosters.TYPE_VACUUM = 23;

cleverapps.Boosters.TYPE_REPLACE_ALL = 20;
cleverapps.Boosters.TYPE_CLEAR_PIECES = 21;
cleverapps.Boosters.TYPE_UNDO_PIECE = 22;

cleverapps.Boosters.TYPE_BOMB = 25;